import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import { CHANGE_TOPIC } from '../Datum/types';
import Checkbox from '../Checkbox/Checkbox';
import Radio from '../Radio/Radio';

var TableCheckbox =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TableCheckbox, _PureComponent);

  var _super = _createSuper2(TableCheckbox);

  function TableCheckbox(props) {
    var _this;

    _classCallCheck(this, TableCheckbox);

    _this = _super.call(this, props);
    _this.handleUpdate = void 0;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TableCheckbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(TableCheckbox.prototype), "componentDidMount", this).call(this);

      this.props.datum.subscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(TableCheckbox.prototype), "componentWillUnmount", this).call(this);

      this.props.datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "handleChange",
    value: function handleChange(_, checked, index) {
      var _this$props = this.props,
          data = _this$props.data,
          datum = _this$props.datum,
          treeColumnsName = _this$props.treeColumnsName;

      if (checked) {
        datum.add(data, index, treeColumnsName);
      } else {
        datum.remove(data, index, treeColumnsName);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          datum = _this$props2.datum;
      var disabled = datum.disabled(data);
      var checked = datum.check(data);
      var CheckItem = datum.limit === 1 ? Radio : Checkbox;
      return (
        /*#__PURE__*/
        React.createElement(CheckItem, Object.assign({}, this.props, {
          checked: checked,
          disabled: disabled,
          onChange: this.handleChange
        }))
      );
    }
  }]);

  return TableCheckbox;
}(PureComponent);

export { TableCheckbox as default };